import React from 'react';
import SEO from '@/components/SEO';
import Services from '../components/Services';
import RetailLoans from '../components/RetailLoans';

const ServicesPage = () => {
  return (
    <>
      <SEO
        title="Our Services - AssetWise Business Consultants"
        description="Comprehensive loan services, real estate consulting, and legal advisory. Expert guidance for all your financial needs with 40+ years of banking expertise."
        path="/services"
        keywords="loan services, real estate consulting, legal advisory, property valuation, conveyance, loan documentation"
      />
      
      <div className="pt-20">
        <Services />
        <RetailLoans />
      </div>
    </>
  );
};

export default ServicesPage;
